import React from "react";
import { Link } from "react-router-dom";
import { GitCompare, X, ArrowRight } from "lucide-react";
import { Button } from "./ui/button";
import { useStore } from "../context/StoreContext";
import { useLang } from "../i18n/LanguageContext";

export const CompareBar = () => {
  const { compare, toggleCompare, clearCompare } = useStore();
  const { t } = useLang();
  if (compare.length === 0) return null;
  return (
    <div data-testid="compare-bar" className="fixed bottom-4 inset-x-0 z-40 px-4 pointer-events-none">
      <div className="container-lumeo">
        <div className="pointer-events-auto glass rounded-2xl border border-border p-3 flex items-center gap-3 shadow-lift-deep max-w-2xl mx-auto">
          <div className="inline-flex items-center gap-2 text-sm px-2">
            <GitCompare className="h-4 w-4 text-cyanx" />
            <span className="font-mono">{compare.length}/3</span>
          </div>
          <div className="flex-1 flex items-center gap-2 overflow-x-auto">
            {compare.map((slug) => (
              <span key={slug} className="chip whitespace-nowrap">
                {slug}
                <button onClick={() => toggleCompare(slug)} className="hover:text-destructive"><X className="h-3 w-3" /></button>
              </span>
            ))}
          </div>
          <button onClick={clearCompare} className="text-xs text-muted-foreground hover:text-foreground px-2">{t("common.clearAll")}</button>
          <Button asChild size="sm" className="btn-glow border-0">
            <Link to="/compare" data-testid="compare-bar-go">{t("nav.compare")} <ArrowRight className="h-4 w-4 ml-1" /></Link>
          </Button>
        </div>
      </div>
    </div>
  );
};
